import IconButton from '@material-ui/core/IconButton'
import clsx from 'clsx'
import React from 'react'
import { useHarmonyIconButtonStyles } from 'shared/hooks/useHarmonyIconButtonStyles'

export interface HarmonyPopoverTriggerProps {
    icon: React.ReactNode
    testId: string
    ariaLabel: string
    disabled?: boolean
    children: (params: {
        anchorEl: HTMLButtonElement | null
        onClose: () => void
    }) => React.ReactNode
}

/**
 * Shared trigger shape for Harmony's popover-based header controls (Help, Notifications):
 * the anchorEl state and the icon button that opens/closes it. Icon and popover content stay
 * with the caller, since neither is shared between today's consumers.
 */
const HarmonyPopoverTrigger = ({
    icon,
    testId,
    ariaLabel,
    disabled,
    children,
}: HarmonyPopoverTriggerProps) => {
    const classes = useHarmonyIconButtonStyles()
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
        null
    )
    const onClose = () => setAnchorEl(null)

    return (
        <>
            <IconButton
                data-testid={testId}
                aria-label={ariaLabel}
                aria-haspopup="true"
                aria-expanded={Boolean(anchorEl)}
                aria-disabled={disabled}
                disableRipple
                disableFocusRipple
                disableTouchRipple
                onClick={(event) => { if (!disabled) setAnchorEl(event.currentTarget) }}
                className={clsx(
                    classes.iconButton,
                    classes.focusRing,
                    anchorEl && classes.iconButtonActive
                )}
            >
                {icon}
            </IconButton>
            {children({ anchorEl, onClose })}
        </>
    )
}

export default HarmonyPopoverTrigger
